/* Kwik Film flyer artwork completion gate - only six draft flyer products. */
(() => {
  'use strict';
  const allowed = new Set(['10337517109467','10337517175003','10337517699291','10337517764827','10337518846171','10337518878939']);
  const initialized = new WeakSet();
  function setup() {
    document.querySelectorAll('product-form-component[data-kwik-flyer="true"]').forEach(host => {
      if (initialized.has(host) || !allowed.has(host.dataset.productId)) return;
      const form = host.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;
      initialized.add(host);
      const map = new Map((host.dataset.kwikUploadMap || '').split(',').map(x => {
        const pair = x.split(':'); return [pair[0], Number(pair[1])];
      }).filter(x => x[0] && (x[1] === 1 || x[1] === 2)));
      const files = new Map();
      const section = host.closest('.shopify-section');
      const status = document.createElement('p');
      status.className = 'kwik-flyer-upload-status';
      status.setAttribute('role','status');
      status.setAttribute('aria-live','polite');
      status.style.cssText = 'font-size:14px;line-height:1.5;margin:12px 0;';
      form.querySelector('.product-form-buttons')?.before(status);
      const required = () => map.get(host.querySelector('input[name="id"]')?.value) || 0;
      const valid = () => required() > 0 && files.size === required();
      let queued = false;
      const update = () => {
        queued = false;
        if (!host.isConnected) return;
        const amount = required(), count = files.size;
        let message = '';
        if (amount === 0) message = 'Choose your flyer variant before adding to cart.';
        else if (count < amount) message = amount === 1
          ? 'Upload one completed artwork file to continue.'
          : 'Upload two completed artwork files (front and back). ' + count + ' of 2 ready.';
        else if (count > amount) message = 'Too many artwork files. Remove the extras before adding to cart.';
        else message = amount === 1 ? 'Artwork uploaded. Ready to add to cart.' : 'Both artwork files uploaded. Ready to add to cart.';
        if (status.textContent !== message) status.textContent = message;
        host.querySelectorAll('button[type="submit"][name="add"]').forEach(button => {
          if (!valid()) {
            if (!button.disabled) button.disabled = true;
            button.dataset.kwikUploadLock = '1';
          } else if (button.dataset.kwikUploadLock === '1') {
            delete button.dataset.kwikUploadLock;
            button.disabled = false;
          }
        });
      };
      const sync = () => { if (!queued) { queued = true; queueMicrotask(update); } };
      const relevant = e => {
        if (!(e.target instanceof Element)) return true;
        const sourceSection = e.target.closest('.shopify-section');
        return !section || !sourceSection || sourceSection === section;
      };
      window.addEventListener('upload:added', e => {
        if (!relevant(e) || !e.detail?.url || e.detail?.meta?.variant === 'thumbnail') return;
        files.set(e.detail.url,e.detail);
        sync();
      });
      window.addEventListener('upload:removed', e => {
        if (relevant(e) && e.detail?.url) files.delete(e.detail.url);
        sync();
      });
      host.addEventListener('change',sync,true);
      document.addEventListener('submit',e => {
        if (e.target !== form || valid()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        status.tabIndex = -1;
        status.focus();
        sync();
      },true);
      new MutationObserver(sync).observe(host,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','value']});
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup);
  else setup();
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(setup).observe(main,{childList:true,subtree:true});
})();
